'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = PlanFeaturesCard;

require('./plan-features-card.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function PlanFeaturesCard(p) {

    var features = p.features;

    return _react2['default'].createElement(
        'div',
        { className: 'm-plan-features-card' },
        _react2['default'].createElement(
            'h1',
            null,
            'KEY FEATURES'
        ),
        _react2['default'].createElement(
            'ul',
            null,
            features.map(function (feature, idx) {

                var featureNote = void 0;
                if (feature.note) {
                    featureNote = _react2['default'].createElement(
                        'small',
                        null,
                        feature.note
                    );
                }

                return _react2['default'].createElement(
                    'li',
                    { key: 'feat-' + idx },
                    feature.number,
                    ' ',
                    feature.name,
                    featureNote
                );
            })
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/v2/plan-features-card.jsx
 ** module id = 1171
 ** module chunks = 0
 **/